export default "__VITE_ASSET__Dzjd9nuF__"